module.exports = __webpack_public_path__ + "static/laboheme9-539bb47e3b4d55f29d145535a90a1655.jpg";